import React, { useState } from "react";
import Table from "../../components/table";
import { TailSpin } from "react-loader-spinner";
import DeleteMediator from "./mediators/delete-mediator";
import Icon from "../../assets/icons";
import { Modal } from "antd";

const MediatorTable = ({ data }: any) => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const userPrivilege = user?.role?.privileges;

  const hasEditMediatorPrivilege = userPrivilege?.some(
    (privilege: any) => privilege.name === 'edit.mediator'
  );


  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const columns = [
    { header: "", accessor: "profilePhoto" },
    { header: "Name", accessor: "fullName" },
    { header: "Email Address", accessor: "email" },
    { header: "Role", accessor: "role" },
    { header: "Date Added", accessor: "createdAt" },
    { header: " ", accessor: "updatedAt" },
  ];

  const handleUserClick = (_id: string) => {
    setSelectedUserId(_id);
  };

  const handleCloseModal = () => {
    setSelectedUserId(null);
  };

  return (
    <div className="rounded-md py-3 px-3 bg-white border border-[#fff] mt-10 w-[95%] pt-5 ">
      <div className="flex justify-between">
        <p className="text-[18px] font-semibold">All Accounts</p>
      </div>

      {isLoading ? (
        <div className="flex justify-center items-center h-64">
          <TailSpin color="skyblue" />
        </div>
      ) : data?.length > 0 ? (
        <Table
          columns={columns}
          data={data}
          selectedUserId={null}
          onUserClick={handleUserClick}
        />
      ) : (
        <div className="flex justify-center items-center h-64">
          <p className="text-gray-500 text-lg">No data available</p>
        </div>
      )}

      {hasEditMediatorPrivilege && selectedUserId ? (
        <DeleteMediator
          visible={!!selectedUserId}
          handleClose={handleCloseModal}
          id={selectedUserId}
        />

      ):(
        <Modal
          visible={!!selectedUserId}
          onCancel={handleCloseModal}
          width={500}
          closable={false}
          footer={null}
        >
          <button onClick={handleCloseModal} className="flex ml-auto">
            <Icon name="cancelIcon" />
          </button>
          <h1 className="text-[#FF2D55] font-semibold text-[24px] text-center py-5">
            You do not have permission to delete this mediator
          </h1>
        </Modal>
      )}
    </div>
  );
};

export default MediatorTable;
